import React, {ReactNode} from "react";
import {Navigate, useLocation} from "react-router-dom";
import {useAuth} from "./AuthContext";
import {roleAccessMap} from "../variables/roleAccessMap";

export const RequireAuth = ({children}: { children: ReactNode }) => {
    const {isLoggedIn, userRole, authLoading} = useAuth();
    const {pathname} = useLocation();
    const allowedRoles: string[] | undefined = roleAccessMap[pathname];

    if (authLoading) {
        return null;
    }

    if (!isLoggedIn) {
        return <Navigate to="/login" replace/>;
    }

    if (allowedRoles && (!userRole || !allowedRoles.includes(userRole))) {
        return <Navigate to="/login" replace/>;
    }

    return <>{children}</>;
};
